import * as SmartDrawings from "../smartDrawings";

export namespace NavigationUtils {

    /**
     * Calculate a target ("look at") vector and the camera up vector from given position and rotation quaternion.
     * Adapted from https://forge.autodesk.com/blog/load-xml-navisworks-saved-viewpoints-forge-viewer-cameras
     * 
     * @param threePos Position of the rotated object (Camera).
     * @param x Rotation quaternion x
    *  @param y Rotation quaternion y
    *  @param z Rotation quaternion z
    *  @param w Rotation quaternion w
     * @param focalLength Camera focal length
     */
    function quaternionToTargetAndUpVectorsImpl(threePos: THREE.Vector3, x: number, y: number, z: number, w: number, focalLength: number): { target: THREE.Vector3, up: THREE.Vector3 } {
        const threeQn = new THREE.Quaternion(x, y, z, w);

        const v1 = -2 * (threeQn.x * threeQn.z + threeQn.w * threeQn.y);
        const v2 = -2 * (threeQn.y * threeQn.z - threeQn.w * threeQn.x);
        const v3 = -1 + 2 * (threeQn.x * threeQn.x + threeQn.y * threeQn.y);

        const threeTarget = new THREE.Vector3(
            threePos.x + focalLength * v1,
            threePos.y + focalLength * v2,
            threePos.z + focalLength * v3
        );

        const u1 = 2 * (threeQn.x * threeQn.y - threeQn.w * threeQn.z);
        const u2 = 1 - 2 * (threeQn.x * threeQn.x + threeQn.z * threeQn.z);
        const u3 = 2 * (threeQn.y * threeQn.z + threeQn.w * threeQn.x);
        const up = new THREE.Vector3(u1, u2, u3);

        return { target: threeTarget, up: up };
    }

    export function quaternionToTargetAndUpVectors(viewParameters: SmartDrawings.ViewParameters, viewer: Autodesk.Viewing.GuiViewer3D): { target: THREE.Vector3, up: THREE.Vector3 } {
        return quaternionToTargetAndUpVectorsImpl(
            viewer.navigation.getPosition(),
            viewParameters.rotationQuaternion.x,
            viewParameters.rotationQuaternion.y,
            viewParameters.rotationQuaternion.z,
            viewParameters.rotationQuaternion.w,
            (viewer.navigation as any).getFocalLength());
    }

}